import { mobileApi, mobileRequest } from './mobileApi';

export const mobileChequeAttachmentService = {
  getAttachments: (chequeId) =>
    mobileRequest(() => mobileApi.get(`/cheques/${chequeId}/attachments`)),

  uploadAttachment: (chequeId, file, documentTypeId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('documentTypeId', documentTypeId);
    return mobileRequest(() =>
      mobileApi.post(`/cheques/${chequeId}/attachments`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 60000,
      })
    );
  },

  downloadAttachment: async (attachmentId) => {
    const response = await mobileApi.get(`/cheque-attachments/${attachmentId}/download`, {
      responseType: 'blob',
    });

    const contentType = response.headers['content-type'] || '';
    if (contentType.includes('application/json')) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      return { success: json.Success ?? json.success, data: json.Data ?? json.data };
    }

    const disposition = response.headers['content-disposition'] || '';
    const fileNameMatch = disposition.match(/filename="?([^";\n]+)"?/);
    const fileName = fileNameMatch ? fileNameMatch[1] : 'attachment';
    const blob = new Blob([response.data], { type: contentType });
    const url = URL.createObjectURL(blob);
    return { success: true, data: { url, fileName, contentType, isBlob: true } };
  },

  deleteAttachment: (attachmentId) =>
    mobileRequest(() => mobileApi.delete(`/cheque-attachments/${attachmentId}`)),

  getDocumentTypes: () =>
    mobileRequest(() => mobileApi.get('/documenttypes')),

  getStorageUsage: () =>
    mobileRequest(() => mobileApi.get('/company-storage')),
};
